import { FC, useRef } from "react";
import { Box } from "@mui/material";
import {
    Modal,
    ModalTitle,
    ModalContent,
    ModalActions,
    Button,
    LoadingButton,
    RequestMessage,
    Loader,
    Settings,
    SettingsItem,
} from "ui";
import { useDispatch } from "react-redux";
import { modalHide } from "app/App/actions";
import GastroPayForm from "../forms/GastroPayForm";
import { TGastroPayModel } from "../types/TGastroPayModel";
import useRequest from "api/useRequest";
import {
    orderLocationModulesGastroPayGateway,
    orderLocationModulesGastroPayUpdate,
} from "app/Order/Locations/actions";
import { AxiosResponse } from "axios";

type TGastroPayUpdateModal = {
    locationId: number;
    onClose: Function;
};

const GastroPayUpdateModal: FC<TGastroPayUpdateModal> = ({
    locationId,
    onClose,
}) => {
    const dispatch = useDispatch();
    const formRef = useRef<any>();
    const { errors, isLoading, message, request, status } = useRequest();
    const { currentData, isPending } = useRequest(
        orderLocationModulesGastroPayGateway(locationId),
    );

    const handleClose = () => {
        dispatch(modalHide("GastroPayUpdateModal"));
    };

    const handleSubmit = (data: TGastroPayModel) => {
        request(
            orderLocationModulesGastroPayUpdate(
                locationId,
                data,
                (response: AxiosResponse) => {
                    if (response.status < 300) {
                        handleClose();
                        onClose();
                    }
                },
            ),
        );
    };

    const handleSaveForm = (
        event: React.FormEvent<HTMLFormElement | HTMLButtonElement>,
    ) => {
        formRef.current?.onSubmit(event, true);
    };

    if (isPending || !currentData.data) {
        return <Loader />;
    }

    return (
        <Modal open maxWidth="xl" fullWidth onClose={handleClose}>
            <ModalTitle onClose={handleClose}>Activate GastroPay</ModalTitle>

            <ModalContent sx={{ p: 2 }}>
                {message && (
                    <Box mb={2}>
                        <RequestMessage message={message} status={status} />
                    </Box>
                )}
                <Settings>
                    <SettingsItem label="UUID">
                        <pre
                            style={{
                                margin: 0,
                            }}
                        >
                            {currentData.data.uuid}
                        </pre>
                    </SettingsItem>
                </Settings>
                <GastroPayForm
                    data={{
                        ...currentData.data.settings,
                        commissions: currentData.data.commissions,
                        sellers: currentData.data.sellers,
                    }}
                    onSubmit={handleSubmit}
                    ref={formRef}
                    errors={errors}
                    loading={isLoading}
                />
            </ModalContent>
            <ModalActions>
                <Box display="flex" width="100%" textAlign="right">
                    <Button
                        onClick={handleClose}
                        color="inherit"
                        variant="text"
                        sx={{ mr: 1 }}
                    >
                        Cancel
                    </Button>
                    <LoadingButton
                        sx={{ flex: 1 }}
                        onClick={handleSaveForm}
                        loading={isLoading}
                    >
                        Save
                    </LoadingButton>
                </Box>
            </ModalActions>
        </Modal>
    );
};

export default GastroPayUpdateModal;
